var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2 10.218C19.2 9.53849 19.139 8.88509 19.0258 8.25781H10V11.9648H15.1576C14.9354 13.1627 14.2602 14.1777 13.2453 14.8572V17.2618H16.3424C18.1545 15.5934 19.2 13.1366 19.2 10.218Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0015 19.5828C12.589 19.5828 14.7583 18.7247 16.3439 17.261L13.2468 14.8565C12.3886 15.4315 11.2909 15.7713 10.0015 15.7713C7.50549 15.7713 5.3928 14.0855 4.6392 11.8203H1.4375V14.3033C3.01439 17.4353 6.2553 19.5828 10.0015 19.5828Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.63899 11.8199C4.44732 11.2449 4.33842 10.6307 4.33842 9.9991C4.33842 9.36747 4.44732 8.75327 4.63899 8.17827V5.69531H1.43729C0.788234 6.98906 0.417969 8.4527 0.417969 9.9991C0.417969 11.5455 0.788234 13.0091 1.43729 14.3029L4.63899 11.8199Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0015 4.22757C11.4085 4.22757 12.6718 4.71109 13.665 5.66071L16.4136 2.91204C14.754 1.36564 12.5847 0.416016 10.0015 0.416016C6.2553 0.416016 3.01439 2.56355 1.4375 5.69556L4.6392 8.17851C5.3928 5.91336 7.50549 4.22757 10.0015 4.22757Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.e34226a762f4128bb39f21ba38dcbc2f.svg";
export { ForwardRef as ReactComponent };